module.exports = __webpack_public_path__ + "img/hjemmelavet-pasta-mel.e91c55e3.jpg";